// extracted by mini-css-extract-plugin
export default {"containerMenu":"styleMenuSuperiorMobile_containerMenu__XsHy3","hamb":"styleMenuSuperiorMobile_hamb__+8OMG"};